import { Button, Grid } from '@material-ui/core'
import React from 'react'
import EditIcon from '@material-ui/icons/Edit'
import PropTypes from 'prop-types'
import { Translate } from 'react-localize-redux'
import LockIconComponent from 'components/UpgradeMembership/LockIconComponent'
import useTeamFeature from 'hooks/useTeamFeature'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'

const LineupEditModeToggler = ({
  isEditMode,
  handleEdit,
  handleCancel,
  handleSave,
}) => {
  const { enabled: hasAdvancedMatchFeaturesEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.advanced_match_features_enable
  )

  return (
    <>
      {!isEditMode ? (
        <Button
          variant="outlined"
          color="primary"
          endIcon={
            !hasAdvancedMatchFeaturesEnabled ? (
              <LockIconComponent context="secondaryButton" />
            ) : (
              <EditIcon />
            )
          }
          onClick={handleEdit}
        >
          <Translate id="button.edit" />
        </Button>
      ) : (
        <Grid container justifyContent="flex-end" spacing={2}>
          <Grid item>
            <Button variant="outlined" color="primary" onClick={handleCancel}>
              <Translate id="button.cancel" />
            </Button>
          </Grid>
          <Grid item>
            <Button variant="contained" color="primary" onClick={handleSave}>
              <Translate id="button.save" />
            </Button>
          </Grid>
        </Grid>
      )}
    </>
  )
}

LineupEditModeToggler.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleEdit: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
}

export default LineupEditModeToggler
